<template>
    <div :class="{'product--show-panel': usePanels, 'product--hide-panel': !usePanels}">
        <slot></slot>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      isDetail: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        shop: 'shop/get',
        isMobile: 'shop/getMetaIsMobile'
      }),
      usePanels () {
        if (this.$route.params.id) return this.usePanelsDetail
        return this.usePanelsOverview
      },
      usePanelsOverview () {
        if (this.isMobile) return this.$_get(this.shop, ['display', 'mobile', 'overview', 'use_panels'])
        return this.$_get(this.shop, ['display', 'desktop', 'overview', 'use_panels'])
      },
      usePanelsDetail () {
        if (this.isMobile) return this.$_get(this.shop, ['display', 'mobile', 'detail', 'use_panels'])
        return this.$_get(this.shop, ['display', 'desktop', 'detail', 'use_panels'])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/ui/productPanel.vue